export default __webpack_public_path__ + "static/media/logo_autopass_for_business.1b268f41.svg";